import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { decodeToken } from 'functions/userAuth';

const AuthLayout=({children})=>{

const [error,setError]=useState(null);


const navigate = useNavigate();
const location = useLocation();
  // Parse the query string into an object
  console.log('locatoin',location );
  sessionStorage.setItem('deepLink',location.pathname);


function isTokenExpired(token) {
  const payload = decodeToken(token);

  const expiresIn = payload.exp; // The expiration time in UNIX timestamp format
  const currentTime = Date.now() / 1000; // Convert current time to UNIX timestamp

  // Compare the current time with the expiration time
  return expiresIn < currentTime;
}


useEffect(()=>{
  // try {
  //   const jwtToken = localStorage.getItem('token');
  //   console.log('jwtToken:', jwtToken);
  //   if (!jwtToken) {
  //     navigate('/authentication/simple/login');
  //     return;
  //   }
  //   const isExpired = isTokenExpired(jwtToken);
  //   console.log('isExpired:', isExpired);
  //   if (isExpired) {
  //     navigate('/authentication/simple/login');
  //     return;
  //   }
  //   sessionStorage.removeItem('deepLink');
  // } catch (err) {
  //   console.log('err: ', err);
  //   navigate('/authentication/simple/login');
  // }
},[])



// axios.interceptors.response.use(
//   (response) => {
//     return response;
//   },
//   (error) => {
//     console.log('axios.interceptors.response from auth layout', error.response);
//     setError({status:error.response.status,message:error.response.data.error})
//     if (error.response.status === 401 || error.response.status === 403) {
//       // Handle Unauthorized error here
//       console.log('auth Unauthorized separated from auth layout', error.response);
//        localStorage.removeItem('token');
//        navigate('/authentication/simple/login');
//     } else {
//       // Handle other errors here

//       console.log('Error:', error.message);
//     }
//     return Promise.reject(error);
//   },
// );

  
    // useEffect(()=>{
    //     if(error){
    //         navigate('/authentication/simple/login');
    //     } 
    //    },[error])

       
    return(
        <>
    {/* {JSON.stringify(error)} */}
        {children}
        </>
    )

}

export default AuthLayout;